import React, { Component } from 'react'

import { Slider, Rail, Handles } from 'react-compound-slider'
import { SliderRail, Handle } from './Components'

import './VideoSlider.scss'

const sliderStyle = {
    position: 'relative',
    width: '100%'
}

export default class VideoSlider extends Component {
    state = {
        currentValue: 0
    }

    onChange = e => {
        const max = this.props.max * 1000
        const length = this.props.length * 1000

        let min = e[0] - (length / 2)
        if (Number.isNaN(min) || min < 0) min = 0
        else if (min > max - length) min = max - length

        this.props.onChangeTime({ min: Math.floor(min), max: Math.floor(min + length) })
    }

    render() {
        const { 
            length, // 비디오 총 길이
            max, // 음악 총 길이
            indicatorValue, 
            videoStartTime, 
            isManualValueChange,
            cropBarColor,
        } = this.props
        let l_max = max * 1000
        let l_length = length * 1000
        let indicatorPosPerc = Math.max(0, Math.min(1, ((indicatorValue % max) / max))) * 100
        if(indicatorValue === 0 && max === 0) {
            // 처음 열었을 때 잠깐동안 슬라이드바가 꽉차있는 상태로 Render되지 않도록 처리
            indicatorPosPerc = 0
            l_max = 1000
            l_length = 0
        }
        else if(indicatorValue === max) indicatorPosPerc = 100

        let curTimeMinutes = Math.floor((indicatorValue === 0) ? 0 : indicatorValue / 60)
        let curTimeSeconds = Math.floor(indicatorValue % 60)
        let curTimeMileseconds =  Math.floor((indicatorValue - Math.floor(indicatorValue)) * 10)

        if(curTimeSeconds < 10) curTimeSeconds = "0" + curTimeSeconds
        if(curTimeMinutes < 10) curTimeMinutes = "0" + curTimeMinutes
        
        let lengthMinutes = Math.floor((max === 0) ? 0 : max / 60)
        let lengthSeconds = Math.floor(max % 60)
        let lengthMileseconds =  Math.floor((max - Math.floor(max)) * 10)

        if(lengthSeconds < 10) lengthSeconds = "0" + lengthSeconds
        if(lengthMinutes < 10) lengthMinutes = "0" + lengthMinutes
        
        return (
            <div className='video-slider-root'>
                <div className='video-slider-curTime'>{`${curTimeMinutes}:${curTimeSeconds}:${curTimeMileseconds}`}</div>
                <Slider
                    mode={1}
                    step={1}
                    domain={[0, l_max]}
                    rootStyle={sliderStyle}
                    onChange={this.onChange}
                    values={[0]}
                >
                    <Rail>
                        {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
                    </Rail>
                    <Handles>
                        {({ handles, getHandleProps }) => (
                            <div className="slider-handles">
                                {handles.map(handle => {
                                    // 직접 값을 바꾸는 경우를 구분지어주지 않으면
                                    // onChange가 호출될 때 SliderBar가 즉시 움직이지 않음.
                                    if(isManualValueChange) {
                                        const halfLengthPerc = (l_length / 2) / l_max * 100
                                        const timePerc = videoStartTime / l_max * 100

                                        handle.value = videoStartTime
                                        handle.percent = timePerc + halfLengthPerc
                                    }
                                    
                                    return (
                                        <Handle
                                            key={handle.id}
                                            handle={handle}
                                            domain={[0, l_max]}
                                            length={l_length}
                                            getHandleProps={getHandleProps}
                                            backgroundColor={cropBarColor ? cropBarColor : '#ff8f44'}
                                        />
                                    )
                                }
                                )}
                            </div>
                        )}
                    </Handles>
                    <div 
                        className='video-slider-indicator-bar'
                        style={{ left: `calc(${indicatorPosPerc}% - 2px)` }}
                    />
                    <div  
                        className='video-slider-indicator-timer'
                        style={{ left: `calc(${indicatorPosPerc}% - 20px)` }}
                    >
                        <span>{`${curTimeMinutes}:${curTimeSeconds}`}</span>
                    </div>
                </Slider>
                <div className='video-slider-duration'>{`${lengthMinutes}:${lengthSeconds}:${lengthMileseconds}`}</div>
            </div>
        )
    }
}